import { useNavigate } from 'react-router-dom';
import { Button } from 'src/components/ui/button';
import { useLazyGetInvoiceLineItemQuery } from 'src/redux/billing/billing.endpoints';
import type { ReviewFlagDTO } from '../types/pipeline.types';

function modelKey(model: string): string {
  return model.toLowerCase();
}

type ReviewFlagOpenButtonProps = {
  readonly flag: ReviewFlagDTO;
};

/**
 * Opens the linked invoice in the invoices tab, or resolves a line item via GET when possible.
 */
export function ReviewFlagOpenButton({ flag }: ReviewFlagOpenButtonProps) {
  const navigate = useNavigate();
  const [fetchLine] = useLazyGetInvoiceLineItemQuery();

  const handleClick = () => {
    const m = modelKey(flag.content_type.model);
    if (m === 'invoice') {
      navigate(`/billing/invoices?invoiceId=${encodeURIComponent(flag.object_id)}`);
      return;
    }
    if (m === 'invoicelineitem') {
      void (async() => {
        try {
          const line = await fetchLine(flag.object_id).unwrap();
          const inv = line.invoice?.trim();
          if (inv) {
            const q = new URLSearchParams({
              invoiceId: inv,
              lineItemId: flag.object_id,
            });
            navigate(`/billing/invoices?${q.toString()}`);
          } else {
            navigate(`/billing/invoices?lineItemId=${encodeURIComponent(flag.object_id)}`);
          }
        } catch {
          navigate(`/billing/invoices?lineItemId=${encodeURIComponent(flag.object_id)}`);
        }
      })();
      return;
    }
    navigate('/billing/pipeline/review');
  };

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      onClick={handleClick}
    >
      Open
    </Button>
  );
}
